// Safe localStorage wrapper. In strict private-browsing modes (Safari/Firefox/Brave)
// accessing window.localStorage can THROW a SecurityError, which would crash the whole
// React app on first render. Every access here is guarded and degrades gracefully.
export const store = {
  get(key, fallback = null) {
    try {
      const v = window.localStorage.getItem(key);
      return v === null ? fallback : v;
    } catch (_) {
      return fallback;
    }
  },
  set(key, value) {
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch (_) {
      return false;
    }
  },
  remove(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (_) {
      /* noop */
    }
  },
};
